import * as React from 'react';
import { FieldArray, InjectedFormProps} from 'redux-form';
import {CheckboxField} from './components/CheckboxField';
import {isRequiredAtleastOne} from '../../util/validators';

interface ICheckboxField {
  label: string;
  name: string;
  value ?: any;
}

interface ICheckboxGroup extends InjectedFormProps {
  name: string;
  fields: ICheckboxField[];
  values: object;
}

export class CheckboxGroup extends React.Component<ICheckboxGroup, any> {
  public render() {
    return (
      <FieldArray
        name={this.props.name}
        component={CheckboxField}
        fields={this.props.fields}
        validate={[isRequiredAtleastOne(this.props.fields, this.props.values)]}
        {...this.props}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/components/CheckboxGroup/index.tsx